export enum REGEX {
  CF = "^(?:(?:[B-DF-HJ-NP-TV-Z]|[AEIOU])[AEIOU][AEIOUX]|[B-DF-HJ-NP-TV-Z]{2}[A-Z]){2}[\\dLMNP-V]{2}(?:[A-EHLMPR-T](?:[04LQ][1-9MNP-V]|[1256LMRS][\\dLMNP-V])|[DHPS][37PT][0L]|[ACELMRT][37PT][01LM])(?:[A-MZ][1-9MNP-V][\\dLMNP-V]{2}|[A-M][0L](?:[1-9MNP-V][\\dLMNP-V]|[0L][1-9MNP-V]))[A-Z]|\\d{11}$",
	EMAIL = "^$|^[a-zA-Z0-9._-]{2,}\\@[a-zA-Z0-9.-]{2,}\\.[a-zA-Z]{2,}$",
  ACCISA = "^[I]{1}[T]{1}[A-Z0-9]{11}$"
}
